export default __webpack_public_path__ + "static/media/TruckStation.256.caf79b1a.png";